export const ACELERACION_GRAVEDAD=9.81
export const UMBRAL_DE_DESVIACION = 4

export const EVENT_BLE='EVENT_BLE'

